const API_URL = process.env.REACT_APP_API_URL || 'https://orders.fletaime.com';

function mapApiProduct(p) {
  return {
    id: p.id,
    name: p.name,
    name_en: p.name_en || null,
    name_de: p.name_de || null,
    category: p.category || 'travel',
    shortDescription: p.short_description,
    shortDescription_en: p.short_description_en || null,
    shortDescription_de: p.short_description_de || null,
    fullDescription: p.full_description,
    fullDescription_en: p.full_description_en || null,
    fullDescription_de: p.full_description_de || null,
    price: p.price,
    originalPrice: p.original_price,
    features: p.features || [],
    features_en: p.features_en || null,
    features_de: p.features_de || null,
    imageUrls: p.image_urls || [],
    createdAt: p.created_at || null,
    isBestseller: p.is_bestseller || false,
  };
}

// Get all products from database
export const getAllProducts = async () => {
  const res = await fetch(`${API_URL}/api/products`);
  if (!res.ok) throw new Error('API error');
  const data = await res.json();
  return data.map(mapApiProduct);
};

// Sync empty array (used for initial render before API response)
export const getAllProductsSync = () => [];

// Get product by ID from database
export const getProductById = async (id) => {
  const res = await fetch(`${API_URL}/api/products/${parseInt(id)}`);
  if (!res.ok) throw new Error('Not found');
  const p = await res.json();
  return mapApiProduct(p);
};
